import _ from 'lodash'
import DisplayUtils from './DisplayUtils'
import URLUtils from './URLUtils'
import MiscUtils from './MiscUtils'
import { FE_ROUTE, HTTP_ERROR_CODE, I18NFormatMessage, TEXT_NOTIFICATION_ERROR } from '../config'

export default class ErrorHandlerUtils {
  static extractErrorMessage(error) {
    // Case 1:  when Backend return error by "throw new Error("error message")
    //          then error.response.data == {"error": "error message"}
    // Case 2:  not often, when do some validation in backend
    //          then error.response.data == {"error": {"field_1: "error 1", "field_2": "error 2"}}
    // Case 3:  when Backend stopped or unexpected exceptions which are not handled by Backend code
    let errorMessage = _.get(error, 'response.data.error', null)

    // Case 1 & 2
    if (errorMessage) {
      if (_.isObject(errorMessage)) {
        // case 2
        errorMessage = _.get(errorMessage, _.keys(errorMessage)[0], 'Unknown error')
      }
      // else: Case 1
    } // Case 3, for example "Network error"
    else errorMessage = error.message
    return errorMessage
  }

  static preCheck(error) {
    // force user logout if admin change role
    const errorStatus = _.get(error, 'response.status', null)
    if (errorStatus && errorStatus === HTTP_ERROR_CODE.FORBIDDEN)
      URLUtils.moveToURL(FE_ROUTE.ERROR.FORBIDDEN_LOGOUT)
    else if (errorStatus && errorStatus === HTTP_ERROR_CODE.NOT_FOUND)
      URLUtils.moveToURL(FE_ROUTE.ERROR.NOT_FOUND)
  }

  static http(error, intl) {
    this.preCheck(error)
    DisplayUtils.showNotificationError(this.extractErrorMessage(error), intl)
  }

  static toText(error, intl) {
    this.preCheck(error)
    const message = this.extractErrorMessage(error)
    return I18NFormatMessage(
      intl,
      _.get(TEXT_NOTIFICATION_ERROR, MiscUtils.slugify(message), message),
    )
  }
}
